import React from 'react';
import { useAppSelector } from '../store/hooks';
import { selectModalOnboarding, selectModalPractice } from '../store/onboardingSlice';
import { selectBaseUrl, selectStageCheckList } from '../store/trainingWorkflowSlice';
import { GenericUpdateForm } from '../OnboardingViewModal';
import { Checklist } from './OnboardingViewHelpers';
import './TrainingWorkflowModal.css';

const TrainingWorkflowModal = ()  => {
  // Redux state
  const modalOnboarding = useAppSelector(selectModalOnboarding);
  const modalPractice = useAppSelector(selectModalPractice);
  const baseUrl = useAppSelector(selectBaseUrl);
  const stageCheckList = useAppSelector(selectStageCheckList);

  console.log("TrainingWorkflowModal: ", modalOnboarding, modalPractice);

  // Get training workflow data from the onboarding object
  const trainingWorkflow = modalOnboarding?.stages?.trainingWorkflow?.status === 'completed';

  const formatBoolean = (value) => {
    return value ? 'Completed' : 'No';
  };

  return (
    <div className="space-y-4">
      
      { modalOnboarding && (
        <div>
          <p className={`training-workflow-status${trainingWorkflow ? ' training-workflow-status-active' : ' training-workflow-status-inactive'}`}>{formatBoolean(trainingWorkflow)}</p>
          <GenericUpdateForm onboarding={modalOnboarding} stage="trainingWorkflow" baseUrl={baseUrl} />
          
          {/* Checklist Component */}
          <Checklist 
            stage="trainingWorkflow" 
            onboarding={modalOnboarding} 
            stateCheckList={stageCheckList} 
          />
        </div>
      )}
    </div>
  );
};

export const displayHistoryTrainingWorkflow = (onboarding) => {
  // For now, return a simple table row with placeholder data
  // In the future, this would parse actual history data from the onboarding object
  return (
    <tr className="training-workflow-history-row">
      <td className="training-workflow-history-cell">
        {new Date().toLocaleString()}
      </td>
      <td className="training-workflow-history-cell">
        Not set
      </td>
      <td className="training-workflow-history-cell">
        {onboarding.stages?.trainingWorkflow?.status ? '✅' : '❌'}
      </td>
      <td className="training-workflow-history-cell">
        Initial status
      </td>
    </tr>
  );
};

export { TrainingWorkflowModal };
